import { BusinessUnitAccessRowValues, DataAccessPolicyValues } from './types';

export const BUSINESS_UNIT_ACCESS_INITIAL_VALUES: BusinessUnitAccessRowValues =
  {
    id: null,
    _rowTimestamp: null,
    businessUnitId: null,
    isPrimary: false,
    _isUpdatable: true,
    _isDeletable: true,
  };
export const DATA_ACCESS_POLICY_VALUES: DataAccessPolicyValues = {
  name: null,
  description: null,
  isAdditionalTagAccessRequired: null,
  isDocumentPoolNullDepartmentAccessible: null,
  isDocDocumentAccess: null,
  documentsDepartmentGroupId: null,
  isPoDocumentAccess: null,
  purchaseOrderDepartmentGroupId: null,
  isTransDocumentAccess: null,
  transactionsDepartmentGroupId: null,
  isTaDocumentAccess: null,
  travelAuthorizationDepartmentGroupId: null,
  isAllBusinessUnits: null,
  isAllWorkgroups: null,
  isAllTagAccess: null,
  isAllProjects: null,
  dataAccessBusinessUnits: [],
};
